import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const appsSlice = createSlice({
  name: "apps",
  initialState,
  reducers: {
    loading(state) {
      state.loading = true;
      state.error = null;
    },
    error(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setList(state, action) {
      state.loading = false;
      state.data = action.payload;
    },

    appsLoading(state) {
      state.loading = true;
      state.error = null;
    },
    appsError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setAppsList(state, action) {
      state.loading = false;
      state.appsList = action.payload;
    },
  },
});

export const { loading, error, setList, appsLoading, appsError, setAppsList } =
  appsSlice.actions;

export default appsSlice.reducer;
